import axios from 'axios';
const API_URL = '/api/profile';

export const getUserProfile = async (userId) => {
  const res = await axios.get(`${API_URL}/${userId}`);
  return res.data;
};

export const saveUserProfile = async (profileData) => {
  const res = await axios.post(API_URL, profileData);
  return res.data;
};

export const updateUserProfile = async (user_id, profileData) => {
  try {
    const res = await axios.put(`${API_URL}/${user_id}`, profileData);
    return res.data;
  } catch (error) {
    console.error("Error updating user profile: ", error);
    throw error;
  }
}